import script from "./OfferingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferingSummary.vue?vue&type=script&setup=true&lang=js"

import "./OfferingSummary.vue?vue&type=style&index=0&id=218c83a6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218c83a6"]])

export default __exports__